<!-- 格力以旧换新订单 -->
<template>
  <div class="app-container">
    <el-form :model="search" :inline="true" label-position="right">
      <el-form-item prop="dateRange">
        <DateRangePicker :allowedDimensions="['month', 'year']" @update:search="handleDateRangeUpdate" />
      </el-form-item>
      <el-form-item label="城市等级">
        <el-select v-model="search.cityLevel" clearable placeholder="请选择">
          <el-option v-for="item in cityLevelList" :key="item" :label="item" :value="item"> </el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="回收商" prop="carrierNo">
        <el-select v-model="search.carrierNo" placeholder="请选择" clearable style="width: 100%">
          <el-option v-for="item in carrierOption" :key="item.carrierNo" :label="item.carrierName" :value="item.carrierNo"> </el-option>
        </el-select>
      </el-form-item>
      <el-button type="primary" size="medium" @click="handleSearch()">查询</el-button>
      <el-button size="medium" @click="handleExport" :loading="exportFlag">导出</el-button>
    </el-form>

    <div class="indicator-container">
      <el-card class="box-card">
        <div slot="header" class="clearfix">
          <span>过程指标</span>
        </div>
        <div class="metric-grid">
          <MetricCard :value="recycleCount" name="申请回收旧机数量" :description="'旧机总的数量'" />
          <MetricCard :value="ableRecycleCount" name="有效旧机数量" :description="'有效的旧机数量'" />
          <MetricCard :value="ableRecycleRate" unit="%" name="旧机有效率" :description="'有效旧机数量/旧机数量'" />
          <MetricCard :value="ableOrderCount" name="有效订单数" :description="'有效的回收单数量'" />
          <MetricCard :value="alreadyRecycleCount" name="已回收量" :description="'状态状态=物流已验收、再生资源已入库的旧机总数量'" />
        </div>
      </el-card>

      <el-card class="box-card">
        <div slot="header" class="clearfix">
          <span>结果指标</span>
        </div>
        <div class="metric-grid">
          <MetricCard :value="avgCompletedDuration" name="平均完工时长" unit="/天" :description="'∑（订单完工时间-订单创建时间）/完工订单数量'" />
          <MetricCard :value="completedRateFirst" name="完工率" unit="%" :description="'完工订单数量/有效订单数量'" />
          <MetricCard :value="completedRateSecond" name="72小时完工率" unit="%" :description="'(完工时间-订单创建时间≤72小时的订单数量)/订单总数量'" />
          <MetricCard :value="outRate" name="超期率" unit="%" :description="'超期的有效订单/有效订单的数量'" />
        </div>
      </el-card>
    </div>

    <div>
      <el-card class="box-card" style="margin-top: 20px;width: 100%;">
        <div slot="header" class="clearfix">
          <span>数据分析</span>
          <div style="float: right; padding: 3px 0">
            <el-dropdown :hide-on-click="false" placement="bottom-start" trigger="click">
              <el-button type="primary"> 切换维度<i class="el-icon-arrow-down el-icon--right"></i> </el-button>

              <el-dropdown-menu slot="dropdown" style="max-height: 300px; overflow-y: auto;">
                <el-checkbox-group v-model="search.dimensionCodeList" @change="handleDimensionChange" class="checkbox-item">
                  <el-checkbox v-for="item in oldMachineCompletedDimensionMap" :key="item.code" :label="item.code">
                    {{ item.name }}
                  </el-checkbox>
                </el-checkbox-group>
              </el-dropdown-menu>
            </el-dropdown>
            <el-dropdown :hide-on-click="false" placement="bottom-start" trigger="click">
              <el-button type="primary"> 切换指标<i class="el-icon-arrow-down el-icon--right"></i> </el-button>
              <el-dropdown-menu slot="dropdown">
                <el-checkbox-group v-model="search.orderInfo" @change="handleMetricChange" class="checkbox-item">
                  <el-checkbox v-for="item in exportField" :key="item.field" :label="item">
                    {{ item.chinese }}
                  </el-checkbox>
                </el-checkbox-group>
              </el-dropdown-menu>
            </el-dropdown>

          </div>
        </div>
        <div class="item-form">
          <el-table :data="list">
            <!-- 动态生成表格列 -->
            <el-table-column label="时间_年" v-if="list.length && list[0].supplyYear" min-width="150" prop="supplyYear" align="center" />
            <el-table-column label="时间_月" v-if="list.length && list[0].supplyMonth" min-width="150" prop="supplyMonth" align="center">
              <template slot-scope="{ row }"> {{ row.supplyYear }}_{{ row.supplyMonth }} </template>
            </el-table-column>
            <el-table-column label="分公司" v-if="list.length && list[0].companyName" min-width="150" prop="companyName" align="center" />
            <el-table-column label="区域_省" v-if="list.length && list[0].provinceName" min-width="150" prop="provinceName" align="center" />
            <el-table-column label="区域_市" v-if="list.length && list[0].cityName && list[0].provinceName" min-width="150" prop="cityName" align="center">
              <template slot-scope="{ row }"> {{ row.cityName }} </template>
            </el-table-column>
            <el-table-column label="城市等级" v-if="list.length && list[0].cityLevel" min-width="150" prop="cityLevel" align="center" />
            <el-table-column label="回收商" v-if="list.length && list[0].carrierName" min-width="200" prop="carrierName" align="center" />

            <el-table-column prop="recycleCount" label="申请回收旧机数量" width="150" align="center" v-if="sortList.includes(1)"></el-table-column>
            <el-table-column prop="ableRecycleCount" label="有效旧机数量" width="150" align="center" v-if="sortList.includes(2)"></el-table-column>
            <el-table-column prop="ableRecycleRate" label="有效旧机率" align="center" width="150" v-if="sortList.includes(3)"></el-table-column>
            <el-table-column prop="ableOrderCount" label="有效订单数" width="150" v-if="sortList.includes(4)" align="center"></el-table-column>
            <el-table-column prop="alreadyRecycleCount" label="已回收量" align="center" v-if="sortList.includes(5)"></el-table-column>
            <el-table-column prop="avgCompletedDuration" label="平均完工时长" width="150" v-if="sortList.includes(6)" align="center">
              <template slot-scope="{ row }"> {{ row.avgCompletedDuration }} / 天 </template>
            </el-table-column>
            <el-table-column prop="completedRateFirst" label="完成率" align="center" width="150" v-if="sortList.includes(7)"></el-table-column>
            <el-table-column prop="completedRateSecond" label="72小时完工率" align="center" width="150" v-if="sortList.includes(8)"></el-table-column>
            <el-table-column prop="outRate" label="超期率" align="center" width="150" v-if="sortList.includes(9)"></el-table-column>
          </el-table>
          <div class="pagination-container">
            <el-pagination
              background
              @size-change="handleSizeChange"
              @current-change="handleCurrentChange"
              layout="total, sizes, prev, pager, next, jumper"
              :current-page.sync="search.page"
              :page-size="search.rows"
              :page-sizes="[10, 20]"
              :total="total"
            >
            </el-pagination>
          </div>
        </div>
      </el-card>
    </div>
  </div>
</template>

<script>
import DateRangePicker from '../components/DateRangePicker.vue'
import MetricCard from '../components/MetricCard.vue'
import { getCityLevelEnum, getPartner, getGreeOldForNew, getExportField, getOldMachineCompletedDimensionMap, getAvgRate } from '@/api/oldForNew'

export default {
  components: {
    DateRangePicker,
    MetricCard
  },
  data() {
    return {
      search: {
        page: 1,
        rows: 10,
        supplyYear: undefined, // 年份
        supplyMonth: undefined, // 月份
        supplyDay: undefined, // 日
        cityLevel: undefined, // 城市等级
        carrierNo: undefined, // 回收商No
        dimensionCodeList: [], //维度code
        orderInfo: [] // 订单信息
      },
      carrierOption: [], // 回收商选项列表
      total: 0,
      list: [],
      cityLevelList: [],
      exportField: [], //导出字段枚举值
      oldMachineCompletedDimensionMap: [], //维度枚举值
      // 过程指标
      recycleCount: 0, // 旧机数量
      ableRecycleCount: 0, // 有效旧机数量
      ableRecycleRate: 0, // 旧机回收有效率
      ableOrderCount: 0, // 有效订单数
      alreadyRecycleCount: 0, // 已回收量
      // 结果指标
      avgCompletedDuration: 0, // 平均完成时长
      completedRateFirst: 0, // 完成率
      completedRateSecond: 0, // 72小时完工率
      outRate: 0, // 超期率
      exportFlag: false,
      dynamicColumns: [], // 动态生成的表格列
      sortList: [1, 2, 3, 4, 5, 6, 7, 8, 9]
    }
  },
  methods: {
    handleDateRangeUpdate(data) {
      if (data.supplyYear) {
        this.search.supplyYear = data.supplyYear
        this.search.supplyMonth = data.supplyMonth
      } else {
        this.search.supplyYear = undefined
        this.search.supplyMonth = undefined
      }
    },
    async handleSearch() {
      // 重置页码为第一页
      this.search.page = 1

      // 获取分页列表数据
      await this.fetchPageList()

      // 获取指标计算
      this.getAvgRate()
    },
    handleSizeChange(val) {
      this.search.rows = val
      this.fetchPageList() // 调用 fetchPageList 重新加载数据
    },
    handleCurrentChange() {
      this.fetchPageList() // 调用 fetchPageList 重新加载数据
    },
    //获取回收商
    async getPartnerList() {
      let { statusCode, data } = await getPartner()
      if (statusCode == 200) {
        this.carrierOption = data
      }
    },

    // 获取分页列表数据
    async fetchPageList() {
      const params = { ...this.search }
      params.supplyYear = this.search.supplyYear ? Number(this.search.supplyYear) : ''
      params.supplyMonth = this.search.supplyMonth ? Number(this.search.supplyMonth) : ''
      params.dimensionCodeList = this.search.dimensionCodeList.map(Number)

      try {
        const res = await getGreeOldForNew(this.global.clearEmptyParam(params))
        if (res.statusCode === 200) {
          this.list = res.data.records || []
          this.total = res.data.total || 0
        }
      } catch (error) {
        console.error('获取分页列表失败:', error)
        this.$message.error('获取分页列表失败')
      }
    },
    //获取城市等级
    async getCityLevelEnum() {
      getCityLevelEnum().then(res => {
        if (res.statusCode === 200) {
          this.cityLevelList = res.data
        }
      })
    },

    //报表指标数据看板计算
    async getAvgRate() {
      const params = this.global.clearEmptyParam(this.search)
      params.supplyYear = this.search.supplyYear ? Number(this.search.supplyYear) : ''
      params.supplyMonth = this.search.supplyMonth ? Number(this.search.supplyMonth) : ''
      params.dimensionCodeList = this.search.dimensionCodeList.map(Number)

      try {
        const res = await getAvgRate(params)
        if (res.statusCode === 200) {
          if (res.data) {
            // 过程指标
            this.recycleCount = res.data.recycleCount || 0 // 旧机数量
            this.ableRecycleCount = res.data.ableRecycleCount || 0 // 有效旧机数量
            this.ableRecycleRate = res.data.ableRecycleRate || 0 // 旧机回收有效率
            this.ableOrderCount = res.data.ableOrderCount || 0 // 有效订单数
            this.alreadyRecycleCount = res.data.alreadyRecycleCount || 0 // 已回收量

            // 结果指标
            this.avgCompletedDuration = res.data.avgCompletedDuration || 0 // 平均完成时长
            this.completedRateFirst = res.data.completedRateFirst || 0 // 完成率
            this.completedRateSecond = res.data.completedRateSecond || 0 // 72小时完工率
            this.outRate = res.data.outRate || 0 // 超期率
          } else {
            // data为null时，所有指标都展示0
            this.recycleCount = 0
            this.ableRecycleCount = 0
            this.ableRecycleRate = 0
            this.ableOrderCount = 0
            this.alreadyRecycleCount = 0
            this.avgCompletedDuration = 0
            this.completedRateFirst = 0
            this.completedRateSecond = 0
            this.outRate = 0
          }
        }
      } catch (error) {
        console.error('获取指标计算失败:', error)
        this.$message.error('获取指标计算失败')
      }
    },
    //获取导出字段枚举值
    async getExportField() {
      try {
        const res = await getExportField()
        if (res.statusCode === 200 && res.data) {
          this.exportField = res.data
          this.search.orderInfo = res.data
          this.sortList = res.data.map(item => item.sort)
          console.log('----getExportField----', res.data, this.sortList)
          this.handleMetricChange()
        }
      } catch (error) {
        console.error('获取导出字段枚举值失败:', error)
        this.$message.error('获取导出字段枚举值失败')
      }
    },
    //获取维度枚举值
    async getOldMachineCompletedDimensionMap() {
      try {
        const res = await getOldMachineCompletedDimensionMap()
        if (res.statusCode === 200 && res.data) {
          // 数据格式转换：将 Map<String, String> 转换为 {code, name} 格式
          this.oldMachineCompletedDimensionMap = res.data.map(item => {
            const [key, value] = Object.entries(item)[0]
            return {
              code: key,
              name: value
            }
          })
        }
      } catch (error) {
        console.error('获取维度枚举值失败:', error)
        this.$message.error('获取维度枚举值失败')
      }
    },
    // 导出
    handleExport() {
      this.exportFlag = true
      const params = {
        ...this.search
      }
      params.supplyYear = this.search.supplyYear ? Number(this.search.supplyYear) : ''
      params.supplyMonth = this.search.supplyMonth ? Number(this.search.supplyMonth) : ''
      params.dimensionCodeList = this.search.dimensionCodeList.map(Number)
      params.orderInfo = this.search.orderInfo.map(item => ({
        ...item,
        select: 1
      }))

      const url = `/autoapp-default-server-recovery/api/dataBorad/oldMachineRate/export/pageCondition`
      this.HttpService.post(url, params).then(res => {
        if (res.statusCode == 200) {
          this.$message.success('正在导出, 稍后请到下载中心查看')
          this.exportFlag = false
        } else {
          this.$message.warning(res.message)
        }
      })
    },
    // 维度多选框
    handleDimensionChange(selectedCodes) {
      let newSelected = [...selectedCodes]

      // 检查是否包含 '3' 但不包含 '2'，如果是则自动添加 '2'
      if (newSelected.includes('3') && !newSelected.includes('2')) {
        newSelected.push('2')
      }

      // 检查是否包含 '4' 但不包含 '3'，如果是则自动添加 '3'
      if (newSelected.includes('5') && !newSelected.includes('4')) {
        newSelected.push('4')
      }
      // 阶段二：删除依赖项
      // 如果用户取消选择 '1'，而仍保留了 '2'，则阻止此操作并提示用户
      if (!newSelected.includes('2') && newSelected.includes('3')) {
        this.$message.warning('请先取消勾选月份，再取消勾选年')
        newSelected.push('2')
        return // 中断操作，保持原状态
      }

      // 如果用户取消选择 '3'，而仍保留了 '4'，则阻止此操作并提示用户
      if (!newSelected.includes('4') && newSelected.includes('5')) {
        this.$message.warning('请先取消勾选城市，再取消勾选省份')
        newSelected.push('4')
        return
      }

      // 过滤掉不符合条件的选项后更新数据
      this.search.dimensionCodeList = newSelected.sort((a, b) => parseInt(a) - parseInt(b))
      this.handleSearch()
    },
    handleMetricChange(selectedMetrics) {
      if (!selectedMetrics) {
        return
      }
      // 更新 search.orderInfo 并排序
      this.search.orderInfo = selectedMetrics.sort((a, b) => a.field.localeCompare(b.field))
      this.sortList = selectedMetrics.map(item => item.sort)
      this.handleSearch()
    }
  },
  mounted() {
    this.search.dimensionCodeList = ['1', '2', '3', '4', '5', '6', '7'] //默认全选
    this.getCityLevelEnum()
    this.getPartnerList()
    this.getExportField()
    this.getOldMachineCompletedDimensionMap()
    this.handleSearch()
  }
}
</script>

<style lang="scss" scoped>
.indicator-container {
  display: flex;
  gap: 16px;
  margin-bottom: 16px;
}

.metric-grid {
  display: flex;
  flex-wrap: wrap;
  gap: 16px;
  align-items: stretch;
}

.box-card {
  flex: 1;
  min-width: 0;

  /deep/ .el-card__header {
    padding: 12px 20px;
    background-color: #f5f7fa;
    border-bottom: 1px solid #e8e8e8;
  }

  /deep/ .el-card__body {
    padding: 16px;
  }
}

.clearfix:before,
.clearfix:after {
  display: table;
  content: '';
}
.clearfix:after {
  clear: both;
}

.row {
  margin-bottom: 15px;
}
.item-form {
  width: 100%;
}
.checkbox-item {
  display: flex;
  flex-direction: column;
  padding: 8px;
  gap: 8px;
}
</style>



// WEBPACK FOOTER //
// src/views/dataBoard/performanceMonitoring/greeOldForNew.vue